module.exports = __webpack_public_path__ + "static/parcelboundaryhoc-0aa10d814c31c6a6dd6331cf554851ce.gif";